import React from "react"
import {FieldViewProps} from "../../../../render/view"

import PropertyGray from "../../../../../gd-components/properties/property-gray/property-gray"
import ErrorBoundary from "../../../../../error-boundary"

export default function FieldTaskStatus_ViewProperty(props: FieldViewProps) {

    const value = props.field.getViewValue(props.model)

    const status = gd.session.statuses.get(value)
    const statusColor = status.color

    const classes = Classes("p-l-0 p-r-0", props.className)
    const listClasses = Classes("ui5-status-list", "status-c{0}".f(statusColor))

    return (
        <PropertyGray className={classes} background={false}>
            <ErrorBoundary>
                <div className={listClasses}>
                    {status.name}
                </div>
            </ErrorBoundary>
        </PropertyGray>
    )
}